import React from 'react';
import './index.css';

import { Col, Row } from 'antd';

const SiteDown = () => {
  
  const backgroundStyle = {
    backgroundImage: "url(/img/others/img-17.jpg)",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  };

  return (
    <div className="h-100" style={backgroundStyle}>
      <div
        className="container d-flex flex-column justify-content-center"
        style={{ marginTop: "6rem" }}
      >
        <Row justify="space-between">
          <div className={"building-wrapper"}>
            <div class="text-center login-page-content">
              <h1>
              We'll be back soon!
              </h1>
              <p>
              Sorry for the inconvenience, but we're performing some maintenance at the moment. <br/>Kindly wait for sometime; we'll be back online shortly!
              </p>
              <p>Tech Team <br/>Smartworks</p>
              <img
                class="building"
                src="/img/client/login-building.png"
                alt="Buildings"
              />
            </div>
          </div>

          
        </Row>
      </div>
    </div>
  );
};

export default SiteDown;


